import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, Routes, Route } from "react-router-dom";
import Attire from './views/attire';
import Home from './views/home';
import Registry from './views/registry';
import Reviews from './views/reviews';
import Rsvp from './views/rsvp';
import Event from './views/event';
import Schedule from './views/schedule';
import Travel from './views/travel';
import ScrollToTop from './components/scroll-to-top';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <ScrollToTop/>
      <Routes>
        <Route path="*" element={<Home />} />
        <Route path="/event" element={<Event />} />
        <Route path="/registry" element={<Registry />} />
        <Route path="/rsvp" element={<Rsvp />} />
        <Route path="/schedule" element={<Schedule />} />
        <Route path="/travel" element={<Travel />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/attire" element={<Attire />} />
      </Routes>
    </HashRouter>

  </React.StrictMode>
);

